export default function IntroSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              We Understand Your <span className="text-teal-600">Unique Situation</span>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Dealing with a hoarder house can be overwhelming, emotionally draining, and physically exhausting. Whether you've inherited a property filled with decades of accumulated belongings, are helping a family member transition to assisted living, or are facing your own hoarding challenges, we're here to help without judgment.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At TREX RE LLC, we specialize in purchasing hoarder houses in any condition. We've seen it all - from homes with floor-to-ceiling clutter to properties deemed non-livable by traditional standards. Our compassionate approach means you don't have to face the daunting task of cleaning out years of accumulated items before selling.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong className="text-gray-900">The best part?</strong> You don't have to lift a finger. We buy your property exactly as it is, handle all the cleanup, removal, and disposal ourselves, and provide you with a fair cash offer that reflects the true value of your property. No real estate agents, no lengthy listings, no open houses, and absolutely no cleanup required from you.
            </p>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/a904e6f2f5d9c25893fee4ff618118b4.jpg"
              alt="Compassionate assistance with hoarder house sale"
              className="w-full h-full object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white p-6 rounded-xl shadow-xl max-w-xs">
              <p className="text-3xl font-bold mb-1">100%</p>
              <p className="text-sm">Judgment-Free Process</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
